// Explicit same-origin article return context. No history/referrer dependency or storage.
const CONTEXT = 'ayaq_return';
const ARTICLE_PATH = /^(?:\/[a-z]{2}(?:-[a-z]{2})?)?\/blogs\/[^/]+\/[^/]+\/?$/i;
const SOURCE_PATH = /^(?:\/[a-z]{2}(?:-[a-z]{2})?)?\/(?:collections\/[^/]+(?:\/products\/[^/]+)?|products\/[^/]+|blogs\/[^/]+\/[^/]+)\/?$/i;

function safeReturn(value, origin) {
  if (!value || value.length > 4096 || !value.startsWith('/') || value.startsWith('//') || /[\\\u0000-\u0020\u007f]/.test(value)) return null;
  try {
    const rawPath = value.split(/[?#]/, 1)[0];
    const decoded = decodeURIComponent(rawPath);
    if (/[\\\u0000-\u0020\u007f]/.test(decoded) || decoded.includes('//') || decoded.split('/').some(part => part === '.' || part === '..') || /%2f|%5c|%25/i.test(rawPath)) return null;
    const url = new URL(value, origin);
    if (url.origin !== origin || !SOURCE_PATH.test(decoded)) return null;
    // Retain the immediate origin verbatim, including its own return context.
    // Each return is validated independently when that article is rendered.
    return url.pathname + url.search + url.hash;
  } catch { return null; }
}

function contextualArticle(href, current) {
  try {
    const source = new URL(current);
    const target = new URL(href, source);
    if (target.origin !== source.origin || !ARTICLE_PATH.test(target.pathname) || target.pathname === source.pathname) return null;
    const back = safeReturn(source.pathname + source.search + source.hash, source.origin);
    if (!back) return null;
    target.searchParams.set(CONTEXT, back);
    return target.pathname + target.search + target.hash;
  } catch { return null; }
}

function initialize() {
  const main = document.getElementById('MainContent');
  if (!main) return;

  function prepareLink(link) {
    if (!link || link.hasAttribute('data-ayaq-article-return') || link.hasAttribute('download')) return;
    const href = contextualArticle(link.getAttribute('href'), location.href);
    if (href && link.getAttribute('href') !== href) link.setAttribute('href', href);
  }

  function refresh(root = main) {
    const current = new URL(location.href);
    const back = safeReturn(current.searchParams.get(CONTEXT), current.origin);
    main.querySelectorAll('[data-ayaq-article-return]').forEach(link => {
      const href = back || link.getAttribute('data-ayaq-return-fallback');
      if (link.getAttribute('href') !== href) link.setAttribute('href', href);
    });
    if (root.matches?.('a[href]')) prepareLink(root);
    root.querySelectorAll?.('a[href]').forEach(prepareLink);
  }

  refresh();
  // Preserve current filters, variant and anchor even when they change without a reload.
  ['pointerdown', 'focusin', 'click', 'contextmenu'].forEach(type => {
    main.addEventListener(type, event => prepareLink(event.target.closest?.('a[href]')), true);
  });
  // Facets, product dialogs and Theme Editor updates can insert links after initial load.
  new MutationObserver(records => {
    records.forEach(record => {
      if (record.type === 'attributes') prepareLink(record.target);
      else record.addedNodes.forEach(node => { if (node.nodeType === 1) refresh(node); });
    });
  }).observe(main, { childList: true, subtree: true, attributes: true, attributeFilter: ['href'] });
  window.addEventListener('pageshow', () => refresh());
  window.addEventListener('popstate', () => refresh());
  window.addEventListener('hashchange', () => refresh());
}

if (typeof document !== 'undefined') {
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initialize, { once: true });
  else initialize();
}

export { safeReturn, contextualArticle };
